enum MovieVideoActionType {
  FETCH_MOVIE_VIDEO_REQUEST = 'FETCH_MOVIE_VIDEO_REQUEST',
  FETCH_MOVIE_VIDEO_REQUEST_SUCCESS = 'FETCH_MOVIE_VIDEO_REQUEST_SUCCESS',
  FETCH_MOVIE_VIDEO_REQUEST_ERROR = 'FETCH_MOVIE_VIDEO_REQUEST_ERROR',
}

export default MovieVideoActionType
